import { useGetReviewQuery } from "../../store/api/generated/stock-request-api";
import { isNullish } from "../../lib/util/common-util";
import { useMemo } from "react";
import { reviewMeta, ReviewSaved } from "../../lib/object/entity/review";

export function useAppGetReviewQuery(
  arg: Parameters<typeof useGetReviewQuery>[0],
  options?: Parameters<typeof useGetReviewQuery>[1],
  skipOptionalValidations = true, // get系は、skipOptionalValidationsのデフォルトはtrueとする。
): {
  data: ReviewSaved | null;
  isLoading: ReturnType<typeof useGetReviewQuery>["isLoading"];
  refetch: ReturnType<typeof useGetReviewQuery>["refetch"];
  error: ReturnType<typeof useGetReviewQuery>["error"];
} {
  const {
    data: rawData,
    isLoading,
    refetch,
    error,
  } = useGetReviewQuery(arg, options);
  const data = useMemo(() => {
    if (isNullish(rawData)) return null;
    return reviewMeta.toSavedDomainObjectOrNull(
      rawData,
      skipOptionalValidations,
    );
  }, [rawData, skipOptionalValidations]);
  return { data, isLoading, refetch, error };
}
